<template>
  <section class="content">
    <admin-header
      title="Accessorials"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    />
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminAccessorial',
    data () {
      return {
        newEntityScreen: 'Admin - Accessorials',
        searchEntityScreen: 'Admin - Accessorial search',
        filterEventName: 'admin-accessorial-filter',
        filterName: 'AccessorialFilter',
        entityName: 'accessorial',
        transformFilterRequest: true
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminAccessorial.vue?036e6223